// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/common/components/ScoreCard/ScoreCard.css
// module id = 2028
// module chunks = 0